addEventListeners();

const screenWidth = $(window).width();

function mobileMenuToggle(event){

   var targetElement = event.target;

  if(targetElement.tagName  == 'A' || targetElement.tagName  == 'H5' || targetElement.tagName  == 'H6' ) {
   var icon = targetElement.children[1];
  }
    else {
     var icon = targetElement;
    }
  
    if(icon.classList.contains('fa-caret-down')) {
 icon.classList.replace('fa-caret-down','fa-caret-up');
    }
    else if(icon.classList.contains('fa-caret-up')){
        icon.classList.replace('fa-caret-up','fa-caret-down');
    }
      
    }

function addEventListeners(){
   //add DOM Content loaded event listener to perform actions after page is loaded
     //window.addEventListener("load", function(){addEventToSSPagination();});
     window.addEventListener("load", function(){makeFinalCSSChanges();});
     window.addEventListener("load", function(){createMutationObservers();});
     //window.addEventListener("load", function(){addIOSScrollListener();});

  }
function addIOSScrollListener(){
  
      if(screenWidth <= 540) {
      alert("IOSScrollEvent Added");
     document.getElementsByClassName("section-scroll")[0].addEventListener("scroll", function(event){improveIOSBounce();});
}
}

function resizeSSContent() {
  var screenWidth = $(window).width();
  console.log("screen width: " + screenWidth + 'px')

  if(screenWidth < 540 ) {
//calculate size needed for seachspring content container
  var ssItemHeight = $('.ss-item').height();
  var ssItems = $('.ss-item');
  var totalSSItemHeight = 0; 

    console.log(ssItems);
    console.log(ssItems[0]);
    console.log(ssItems[1].clientHeight);
    
       for(let i=0;i<ssItems.length;i++){
        console.log(ssItems[i].clientHeight);
         totalSSItemHeight += ssItems[i].clientHeight * 1;
       }

      console.log("total ss item height: " + totalSSItemHeight + 'px');
      console.log("ss item height: " + ssItemHeight + 'px');
    
  var getResultCount = $('.ss-item').length;

    console.log("results: " + getResultCount);
  var ssResultsHeight = (320 * (getResultCount/2));

  //set results height and ss container height in CSS

  console.log('Calculate results height: ' + totalSSItemHeight);
   $('.ss-results').height((totalSSItemHeight/2) + 200 + 'px'); 
   $('#searchspring-content').height((totalSSItemHeight/2) + 500 + 'px');
}
  
}
function makeFinalCSSChanges(){
   
//remove ss pagination options

   setTimeout(() => {
  $('.ss-per-page').addClass('ss-per-page-hidden');
  $('.ss-per-page-hidden').removeClass('ss-per-page');
}, 500); 
  
}

function iOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

function addEventToSSPagination(){

   console.log('adding event to pagination');
  //once page is loaded add onclick events to SS pagination links


    //$(".ss-item-container").on('change' ,  function(event) {alert("pagination click event started");$.ajaxSetup({ cache: false });console.log(document.getElementsByClassName("section-scroll")[0]);document.getElementsByClassName("section-scroll")[0].scrollTop = 0; console.log("ScrolledToTop" + document.getElementsByClassName("section-scroll")[0].clientTop);window.scrollTo(0,0);$.ajaxSetup({ cache: true });});
   //$("a.ng-binding.ng-scope").on('click touchstart' ,  function(event) {alert("pagination click event started");$.ajaxSetup({ cache: false });console.log(document.getElementsByClassName("section-scroll")[0]);document.getElementsByClassName("section-scroll")[0].scrollTop = 0; console.log("ScrolledToTop" + document.getElementsByClassName("section-scroll")[0].clientTop);window.scrollTo(0,0);$.ajaxSetup({ cache: true });});
  //$("#next-pg").on('click touchstart' ,  function(event) {alert("pagination click event started");$.ajaxSetup({ cache: false });document.getElementsByClassName("section-scroll")[0].scrollTop = 0; console.log("ScrolledToTop" + document.getElementsByClassName("section-scroll")[0].clientTop);window.scrollTo(0,0);$.ajaxSetup({ cache: true });});
   //$("#prev-pg").on('click touchstart' ,  function(event) {alert("pagination click event started");$.ajaxSetup({ cache: false });document.getElementsByClassName("section-scroll")[0].scrollTop = 0; console.log("ScrolledToTop" + document.getElementsByClassName("section-scroll")[0].clientTop);window.scrollTo(0,0);$.ajaxSetup({ cache: true });});
    
 console.log('added event to pagination');
}

function improveIOSBounce(event){
var sectionHeight = 0;
var scrollPos= 0;

  
  sectionHeight = document.getElementsByClassName("section-scroll")[0].clientHeight;
  scrollPos = document.getElementsByClassName("section-scroll")[0].scrollTop;

    if((scrollPos/sectionHeight) >= .9) {
      window.focus();
      document.body.focus();
    }
  
}

function createMutationObservers(){

    setTimeout(() => {

// Select the node that will be observed for mutations
const targetNode = document.getElementsByClassName("ss-item-container")[0];

// Options for the observer (which mutations to observe)
const config = { attributes: false, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === "childList") {
        //console.log(mutation);
    } else if (mutation.type === "attributes") {
      console.log(`The ${mutation.attributeName} attribute was modified.`);
    }
  }    
  makeFinalCSSChanges();
  
    if(iOS() && screenWidth < 540){
  setTimeout(() => {
      document.getElementsByClassName("section-scroll")[0].scrollTop = 0;
      window.scrollTo(0,0);
},100); 
    }
  else{
      document.getElementsByClassName("section-scroll")[0].scrollTop = 0;
      window.scrollTo(0,0);
  }
  
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);
},500); 
}